import "../css/subHeader.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { clearAdminToken } from "../util/auth";
const SubHeader = ({ data }) => {
  const navigate = useNavigate();
  // 지금 서버가 알리고(문자 발송)로 나갈 때 실제로 쓰는 IP를 확인합니다.
  // Railway는 고정 아웃바운드 IP가 유료 기능이라, 이 값이 알리고에
  // 등록해둔 IP와 달라지면 "인증되지 않은 발송 IP입니다" 알림이 옵니다.
  // 여기서 확인한 값을 알리고 관리자 화면(발송 서버 IP)에 다시 등록하면 됩니다.
  const checkOutboundIp = async () => {
    try {
      const { data } = await axios.get("/aligo/outboundIp");
      alert(
        `현재 서버 발송 IP: ${data.ip}\n\n이 값을 알리고 관리자 화면의 "발송 서버 IP"에 등록해주세요.`
      );
    } catch (error) {
      alert(
        error.response?.data?.message || "IP 확인 중 오류가 발생했습니다."
      );
    }
  };
  const logout = async () => {
    try {
      await axios.post("/admin/auth/logout");
    } catch (error) {
      // 로그아웃 자체는 실패해도 어차피 로그인 화면으로 보내면 되므로
      // 사용자에게 별도로 알리지 않습니다.
    } finally {
      // 토큰 방식이므로 실제 로그아웃은 브라우저에 저장된 토큰을 지우는 것입니다.
      clearAdminToken();
      navigate("/login");
    }
  };

  return (
    <div className="subHeader">
      <div className="box">
        <img src="/images/subHeader_img.png" alt="" />
        <p>페이지 관리자</p>
      </div>
      <p>{data}</p>
      <p className="ip_check_btn" onClick={checkOutboundIp}>
        발송 IP 확인
      </p>
      <p className="logout_btn" onClick={logout}>
        로그아웃
      </p>
    </div>
  );
};

export default SubHeader;
